/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var staleHomeAssets = [
    'Banner_fusion.png?v=1779735667',
    'Banner_fusion.png?v=1779736515',
    'Banner_newdrop.png?v=1780142050',
    'Artboard_1_b9d41461-e026-4b4e-8e57-4eea1f6920e5.png?v=1780142051',
    'Artboard_2_ab22978a-4b68-4efd-9d8b-ad6aad9d634e.png?v=1780142051',
    'Sukuna_web.png?v=1772059254',
    'Sukuna_Mobile.png?v=1772059254',
    'spoiler01.png?v=1772725643',
    'spoiler02.png?v=1773091634',
    'Artboard_8.png?v=1775681831'
  ];

  var pageHtml = document.documentElement.innerHTML;
  var needsRefresh = staleHomeAssets.some(function(asset) {
    return pageHtml.indexOf(asset) !== -1;
  });

  if (!needsRefresh || !window.fetch) {
    return;
  }

  var sectionNodes = [
    document.querySelector('[id$="__home_fullscreen_slideshow"]'),
    document.querySelector('[id$="__new_drops_grid"]'),
    document.querySelector('[id$="__coming_soon_gallery"]')
  ].filter(Boolean);

  if (!sectionNodes.length) {
    return;
  }

  var sectionIds = sectionNodes.map(function(section) {
    return section.id.replace(/^shopify-section-/, '');
  });

  var url = new URL(window.location.href);
  url.search = '';
  url.searchParams.set('sections', sectionIds.join(','));
  url.searchParams.set('_', String(Date.now()));

  fetch(url.toString(), { credentials: 'same-origin' })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to refresh home sections');
      }
      return response.json();
    })
    .then(function(sections) {
      sectionNodes.forEach(function(section) {
        var sectionId = section.id.replace(/^shopify-section-/, '');
        var html = sections[sectionId];

        if (!html) {
          return;
        }

        var template = document.createElement('template');
        template.innerHTML = html.trim();
        var freshSection = template.content.firstElementChild;

        if (!freshSection) {
          return;
        }

        section.replaceWith(freshSection);
        freshSection.querySelectorAll('script').forEach(function(script) {
          var executableScript = document.createElement('script');
          Array.prototype.slice.call(script.attributes).forEach(function(attribute) {
            executableScript.setAttribute(attribute.name, attribute.value);
          });
          executableScript.text = script.text;
          script.replaceWith(executableScript);
        });
      });
    })
    .catch(function() {});
})();
